import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
// Returns true if the objects are the "same", false otherwise
var shallowCompare = function shallowCompare(newObject) {
  var prevObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(newObject).reduce(function (flag, key) {
    return !Object.prototype.hasOwnProperty.call(prevObject, key) || newObject[key] !== prevObject[key] ? false : flag;
  }, true);
};
export default shallowCompare;